import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import BuRunCharges_Service from "../../../../services/buRunChargeServices";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./model/BURUNTableColumns";

function BURunChargeTable() {
  const history = useHistory();

  const { buRunChargeState } = useMastersContext();

  useEffect(() => {
    buRunChargeState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => buRunChargeState.data || [], [
    buRunChargeState.data,
  ]);

  const removeHandler = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      debugger;
      const result = await BuRunCharges_Service.remove(id);
      if (result.success === true) {
        buRunChargeState.fetch();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>BU Run Charge</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push("/masters/bu-run-charge/add")}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={buRunChargeState.loading}
        data={data}
        columns={columns}
        idField="burctC_ID"
        onEdit={(id) => history.push(`/masters/bu-run-charge/edit/${id}`)}
        onRemove={removeHandler}
      />
    </div>
  );
}

export default BURunChargeTable;
